import React from "react";
import { OcrProcess } from "./OcrProcessDisplay";
import OcrProcessLineItemBox from "./OcrProcessLineItemBox";

interface OcrProcessBoxProps {
  process: OcrProcess;
}

export default class OcrProcessBox extends React.Component<OcrProcessBoxProps> {
  render() {
    if (
      Array.isArray(this.props.process.lineItems) &&
      this.props.process.lineItems.length > 0
    ) {
      return (
        <>
          <div className="wrapper-leistungsberichte">
            {this.props.process.lineItems &&
              this.props.process.lineItems.map((x, idx) => (
                <OcrProcessLineItemBox
                  item={x}
                  processNumber={this.props.process.processNumber}
                  key={`le-${this.props.process.processNumber}-${idx}`}
                />
              ))}
          </div>
        </>
      );
    }
    return "";
  }
}
